export const matchPrefix = (pattern) => (item) => {
    if (item) {
        const test = item.match(pattern);
        return !!(test && test.length);
    }
    return false;
};
//# sourceMappingURL=match-prefix.js.map